// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e5-a";
export var fulfillmentFormRail = "_e5-9";
export var headerTitleRow = "_e5-c";
export var orderDetailsWrapper = "_e5-7";
export var orderLinkTrigger = "_e5-2";
export var paymentInformationGrid = "_e5-h";
export var paymentSummaryColumn = "_e5-i";
export var shipmentContainer = "_e5-b";
export var shipmentDetailsMainPane = "_e5-8";
export var shipmentNavigationCard = "_e5-5";
export var shipmentNavigationRail = "_e5-3";
export var shipmentNavigationRailHeader = "_e5-4";
export var shipmentSummaryFact = "_e5-e";
export var shipmentSummaryGrid = "_e5-d";
export var shipmentSummaryMetadataRow = "_e5-f";
export var shipmentSummaryTags = "_e5-g";
export var shipmentWorkspace = "_e5-0";
export var shipmentWorkspaceContent = "_e5-6";
export var shipmentWorkspaceHeader = "_e5-1";